import { doc, getDoc, setDoc } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Scenario from '../../models/Scenario';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';

async function createScenario(
  payload: Scenario,
  auth: Authentication
): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new CreateScenarioFailure('Unauthorized', 'unauthorized');
  }

  try {
    const scenarioDoc = payload;

    const scenarioDocData = scenarioDoc.toFirestore();
    const db = firestore;

    const scenarioDocRef = doc(
      db,
      FirestoreCollections.scenarios,
      scenarioDoc.id
    );
    const scenarioDocSnap = await getDoc(scenarioDocRef);

    if (scenarioDocSnap.exists()) {
      throw new CreateScenarioFailure(
        'Scenario already exists',
        'scenario-exists'
      );
    }

    await setDoc(scenarioDocRef, scenarioDocData);

    return;
  } catch (e) {
    console.log('error: ', e);
    throw new CreateScenarioFailure();
  }
}

export class CreateScenarioFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default createScenario;
